// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__HswBA","inline":"styles_inline__E7tO2"};